import React, { Component } from 'react';
import { connect } from 'react-redux';
import DrivingLicenceForm from './DrivingLicenceForm';
import {
  isRenaultFranceUserSelector,
  drivingLicenceFormInitialValuesSelector,
  messagesSelector,
  userCompanyIdSelector,
  userDataSelector,
  userIdSelector
} from '../../helpers/selectors';
import { bindActionCreators } from 'redux';
import * as UserActions from '../../actions/user';
import {
  getFileIdFromField,
  setBackFile,
  setFrontFile,
  toYearDateApi
} from '../../utils/utils';
import { cleanUserDataForApi } from '../../helpers';
import { getLocationProp } from '../partials/LocationInput/utils';
import { displayProfileUpdateSuccess } from '../../helpers/components';

class DrivingLicence extends Component {
  constructor(props) {
    super(props);
    this.bindFunctions();
  }

  bindFunctions() {
    this.updateDrivingLicence = this.updateDrivingLicence.bind(this);
  }

  formatDataForApiCall(userData, formValues) {
    const {
      licenceNumber,
      deliveranceDate,
      cityDeliverance,
      expirationDateNotPresent,
      expirationDate,
      documentFront: drivingFront,
      documentBack: drivingBack
    } = formValues;

    const newData = {
      ...userData,
      drivingLicence: {
        licenceNumber,
        cityDeliverance: getLocationProp(cityDeliverance, ['city', 'streetName']),
        deliveranceDate: toYearDateApi(deliveranceDate),
        expirationDate: toYearDateApi(!expirationDateNotPresent && expirationDate),
        files: [
          setFrontFile(getFileIdFromField(drivingFront)),
          setBackFile(getFileIdFromField(drivingBack))
        ]
      }
    };

    return cleanUserDataForApi(newData);
  }

  updateDrivingLicence(formValues) {
    const {
      m,
      updateInformations,
      userId,
      userData,
      updateInformationsFetching
    } = this.props;

    if (!updateInformationsFetching) {
      updateInformations(userId, this.formatDataForApiCall(userData, formValues)).then(
        (data) => {
          if (data.type === 'user/UPDATE_INFORMATIONS_SUCCESS') {
            displayProfileUpdateSuccess(m, 'label.driving_licence');
          }
        }
      );
    }
  }

  render() {
    const { initialValues, isRenaultFranceUser } = this.props;

    return (
      <DrivingLicenceForm
        onSubmit={this.updateDrivingLicence}
        hideFileUpload={isRenaultFranceUser}
        initialValues={initialValues}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const { updateInformationsFetching } = state.user;
  return {
    userId: userIdSelector(state),
    isRenaultFranceUser: isRenaultFranceUserSelector(state),
    userCompanyId: userCompanyIdSelector(state),
    userData: userDataSelector(state),
    m: messagesSelector(state),
    initialValues: drivingLicenceFormInitialValuesSelector(state),
    updateInformationsFetching
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...UserActions }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(DrivingLicence);



/** WEBPACK FOOTER **
 ** ./src/components/account/DrivingLicence.js
 **/